import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import IconContainer from 'assets/customSVG/sequence/actions/IconContainer';
import FullArrow from 'assets/customSVG/FullArrow';
import { cn } from 'helper/cn';
import { useFunction } from '../../../../../hooks/useFeatureGating';
import { FUNCTIONS } from '../../../../../constant/featureSlugs';

export default function TriggerListContainer({
  triggers,
  onTriggerClick,
  allow,
  isAfterApiTrigger
}) {
  const { limit: messageTypesLimit } = useFunction(FUNCTIONS.SEQUENCE_MESSAGE_TYPES);

  // keys that belong to actions (message types)
  const actionKeys = ['TEXT', 'MEDIA', 'BUTTON', 'LIST', 'TEMPLATE', 'LOCATION_REQUEST_MESSAGE', 'FLOW', 'CTA_URL', 'CONTACTS'];

  // open tempalte message for api trigger
  const openTemplateMessageForApiTrigger = () => {
    const trigger = triggers?.find((trigger) => trigger?.key === 'TEMPLATE');
    if (trigger) {
      onTriggerClick(trigger);
    }
  } 

  useEffect(() => {
    if (isAfterApiTrigger) {
      openTemplateMessageForApiTrigger();
    }
  }, [isAfterApiTrigger])

  return (
    <div className='w-full h-auto flex flex-col items-center gap-2.5 px-4 py-2.5'>
      {triggers?.map((trigger) => {
        const Icon = trigger?.icon;
        
        const isAction = actionKeys.includes(trigger?.key);
        const isGatedByLimit = isAction && messageTypesLimit !== null && messageTypesLimit !== undefined && trigger?.id > messageTypesLimit;
        
        const isGated = trigger?.isGated || isGatedByLimit;
        const isDisabled = trigger?.disabled;
        const canAdd = trigger?.canAdd !== false; // default true if not specified
        const tooltipMessage = trigger?.tooltipMessage || "This feature is not available in your plan. Upgrade to access.";

        return (
          <Tooltip 
            key={trigger?.id}
            title={isGated ? tooltipMessage : (isDisabled && trigger.key !== 'TEMPLATE' ? 'Only template messages are allowed after an API trigger' : '')}
          >
            <div
              className={cn(
                'w-full h-12 flex items-center justify-between gap-2.5 border rounded-lg p-2.5',
                isDisabled && !isGated
                  ? 'border-[var(--border-200)] bg-[var(--BG-100)] cursor-not-allowed opacity-50 hidden'
                  : 'border-[var(--border-input)] cursor-pointer',
                (isGated || !canAdd) ? 'bg-[var(--BG-100)] cursor-not-allowed opacity-50' : "hover:border-[var(--border-50)] hover:bg-[var(--BG-50)]"
              )}
              onClick={(event) => {
                event.stopPropagation();
                if (!isGated && allow && onTriggerClick && !isDisabled && canAdd) {
                  onTriggerClick(trigger);
                }
              }}
            >
              <div className='w-full flex items-center gap-2.5'>
                {Icon && (
                  <IconContainer color={trigger?.bg}>
                    <Icon color={trigger?.color} />
                  </IconContainer>
                )}
                <p className={cn(
                  'text-sm weight-medium',
                  (isDisabled || isGated) ? 'text-[var(--contentText-300)]' : 'text-[var(--contentText)]'
                )}>
                  {trigger?.label}
                  {isDisabled && !isGated && trigger.key !== 'TEMPLATE' && (
                    <span className='ml-2 text-xs text-amber-500'>
                      (Not allowed after API Trigger)
                    </span>
                  )}
                </p>
              </div>
              <div className='size-6 flex items-center justify-center'>
                <FullArrow
                  width={16}
                  height={16}
                  color={'#898E99'}
                />
              </div>
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}
